import { db } from "../../firebase";
import { addDoc, collection } from "firebase/firestore";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import getDeviceTokensFromFirestore, {
  getEmailFromFirestore,
  getUidFromFirestore,
  getUidFromFirestoreAgents,
  getUidFromProperty,
  getUidFromFirestoreDeals,
} from "./get_tokens";

const addNotification = async (
  title,
  description,
  notification_type,
  image,
  notification_link,
  record_id,
  receiver_id,
  is_seen,
  is_deleted
) => {
  try {
    const NotificationsCollection = collection(db, "notifications");

    let uid = "";
    let pid = "";

    //Here receive_id is bid, by businesss id, we get uid from client Collection and then we perform rest of processing
    if (notification_type === "Shared") {
      uid = await getUidFromFirestore(receiver_id);
    }

    //Here receiver_id is  property_id, we get uid from property collection and then perform rest of work
    else if (
      notification_type === "Deal is Won" ||
      notification_type === "Deal is Open" ||
      notification_type === "Log Visitor"
    ) {
      pid = receiver_id;
      uid = await getUidFromProperty(receiver_id);
      if (uid === "NO") {
        return;
      }
    }

    let deviceIDs = await getDeviceTokensFromFirestore(uid);
    let email = "";
    let userData = await getEmailFromFirestore(uid);
    email = userData.email;
    // if (notification_type === "Shared") {
    //   title = userData.businessName + title;
    //   description = userData.businessName + description;
    // if (
    //   notification_type === "Deal is Won" ||
    //   notification_type === "Deal is Open"
    // ) {
    //   title = userData.name + title;
    //   description = userData.name + description;
    // }
    if (!email) {
      email = "";
    }
    await addDoc(NotificationsCollection, {
      title: title,
      image: image,
      description: description,
      notification_type: notification_type,
      notification_link: notification_link,
      device_id: deviceIDs,
      record_id: record_id,
      receiver_id: uid,
      is_deleted: is_deleted,
      is_seen: is_seen,
      email: email,
      ...HelperForMetaData({}),
    });

    if (notification_type === "Shared") {
      let agents = getUidFromFirestoreAgents(receiver_id);
      for (let i = 0; i < agents.length; i++) {
        uid = agents[i];
        let deviceIDs = await getDeviceTokensFromFirestore(uid);
        let email = "";
        let userData = await getEmailFromFirestore(uid);
        email = userData.email;
        if (!email) {
          email = "";
        }
        await addDoc(NotificationsCollection, {
          title: title,
          image: image,
          description: description,
          notification_type: notification_type,
          notification_link: notification_link,
          device_id: deviceIDs,
          record_id: record_id,
          receiver_id: uid,
          is_deleted: is_deleted,
          is_seen: is_seen,
          email: email,
          ...HelperForMetaData({}),
        });
      }
    } else if (notification_type === "Deal is Won") {
      let dealMadeBy = uid;
      let dealsPersons = getUidFromFirestoreDeals(pid);
      for (let i = 0; i < dealsPersons.length; i++) {
        uid = dealsPersons[i];
        if (dealMadeBy === uid) {
          continue;
        }
        let deviceIDs = await getDeviceTokensFromFirestore(uid);
        let email = "";
        let userData = await getEmailFromFirestore(uid);
        email = userData.email;

        if (!email) {
          email = "";
        }
        await addDoc(NotificationsCollection, {
          title: title + " and Your Deal is Moved to Archived Deals.",
          image: image,
          description:
            description + " and Your Deal is Moved to Archived Deals.",
          notification_type: notification_type,
          notification_link: notification_link,
          device_id: deviceIDs,
          record_id: record_id,
          receiver_id: uid,
          is_deleted: is_deleted,
          is_seen: is_seen,
          email: email,
          ...HelperForMetaData({}),
        });
      }
    }

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default addNotification;
